/* istanbul ignore file */
import React from 'react';
import Condition, { ConditionProps } from './Condition';
import { FilterCondition } from 'framework/types';

const EqCondition = ({ children, ...conditionProps }: ConditionProps) => {
  return (
    <Condition {...conditionProps} conditionType={FilterCondition.EQ}>
      {children}
    </Condition>
  );
};

export default EqCondition;
